import {
  AGENT_TOOLS,
  type LocalAgentTool,
  LOCAL_TOOL_CATALOG,
  LOCAL_TOOL_GROUP_LABELS,
  LOCAL_TOOL_GROUPS,
} from '@sbc/domain-models/agents';

import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const GROUPED_TOOLS = LOCAL_TOOL_GROUPS.map((group) => ({
  group,
  tools: AGENT_TOOLS.filter((tool: LocalAgentTool) => LOCAL_TOOL_CATALOG[tool].group === group),
})).filter((entry) => entry.tools.length > 0);

export function LocalToolsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Tools</h1>
        <p className="text-sm text-[var(--color-muted-foreground)]">
          Local, code-defined tools available to every agent. MCP tools are curated per server under
          MCP → Servers.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">Local tools</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          {GROUPED_TOOLS.length ? (
            GROUPED_TOOLS.map(({ group, tools }) => (
              <div key={group} className="space-y-2">
                <h2 className="text-sm font-medium">{LOCAL_TOOL_GROUP_LABELS[group]}</h2>
                <ul className="space-y-2 text-sm">
                  {tools.map((tool) => (
                    <li key={tool} className="flex items-center justify-between">
                      <span>{LOCAL_TOOL_CATALOG[tool].label}</span>
                      <Badge variant="secondary">Always available</Badge>
                    </li>
                  ))}
                </ul>
              </div>
            ))
          ) : (
            <p className="text-sm text-[var(--color-muted-foreground)]">No local tools defined.</p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
